import { SW_INIT, SW_UPDATE, DB_COL } from './types';

function rootReducer(state = {}, action) {
  switch (action.type) {
    case SW_INIT:
      return {
        ...state,
        serviceWorkerInitialized: !state.serviceWorkerInitialized,
        serviceWorkerRegistration: action.payload,
      };
    case SW_UPDATE:
      return {
        ...state,
        serviceWorkerUpdated: !state.serviceWorkerUpdated,
        serviceWorkerRegistration: action.payload,
      };
    case DB_COL:
      return {
        ...state,
        collections: !state.collections,
      };
    default:
      return state;
  }
}

export default rootReducer;